import styled from '@emotion/styled';

import CompleteBg from '@/assets/icons/icon_complete.svg';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const Wrapper = styled.div(() =>
  mq({
    width: '100%',
    padding: [
      `0 ${defaultTheme.spacing.l}`,
      `0 ${defaultTheme.spacing.l}`,
      '0',
      '0',
    ],
  }),
);

export const CompleteMessageWrapper = styled.div(() =>
  mq({
    width: '100%',
    textAlign: 'center',
    backgroundColor: defaultTheme.background.white,
    padding: `${defaultTheme.spacing.xxl} 0`,
    margin: '0 auto',
    '& > p': {
      fontSize: defaultTheme.font.size.xl,
      fontWeight: 'bold',
      marginBottom: defaultTheme.spacing.l,
    },
  }),
);

export const CompleteIcon = styled.div(() =>
  mq({
    width: '48px',
    height: '48px',
    backgroundImage: `url(${CompleteBg})`,
    backgroundSize: 'cover',
    margin: '0 auto',
  }),
);

export const CurrentRaceWrapper = styled.div(() =>
  mq({
    width: '100%',
    marginTop: '40px',
    '& > span': {
      padding: `${defaultTheme.spacing.l} 0 40px`,
    },
  }),
);

export const CurrentRaceTitle = styled.p(() =>
  mq({
    fontSize: defaultTheme.font.size.l,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: defaultTheme.spacing.l,
  }),
);

export const Notice = styled.p(() =>
  mq({
    color: defaultTheme.text.gray,
    fontSize: defaultTheme.font.size.xs,
    textAlign: 'center',
    margin: `${defaultTheme.spacing.l} 0 40px`,
  }),
);

export const BlackSection = styled.section(() =>
  mq({
    marginTop: '16px',
    backgroundColor: defaultTheme.background.black,
    width: '100%',
  }),
);
